import React from 'react'
import NumberFormat from 'react-number-format'

export function NumberFormatCustom(props) {
	const { inputRef, onChange, ...other } = props

	return (<NumberFormat
	{...other}
	getInputRef={ref => {
		// Se inputRef for um objeto com a propriedade current (React.createRef())
		if (inputRef && typeof inputRef === 'object' && 'current' in inputRef) {
			inputRef.current = ref;
		}
		// Se inputRef for uma função
		else if (typeof inputRef === 'function') {
			inputRef(ref);
		}
	}}
	onValueChange={(values) => {
		onChange({
			target: {
				name: props.name,
				value: values.value,
			},
		})
	}}
	thousandSeparator={'.'}
	decimalSeparator={','}
	decimalScale={2}
	isNumericString
	/>)
}
